import {
  Layout,
  Globe,
  FileText,
  Database,
  ShoppingBag,
  Store,
  Briefcase,
  Mail,
  TrendingUp,
  Camera
} from 'lucide-react';

export const getPackages = (t) => [
  {
    id: 'starter',
    name: t('prijzen.starter.name', 'Starter'),
    price: 550,
    oldPrice: 750,
    newPrice: 499,
    badge: t('prijzen.starter.badge', 'Ideaal voor Starters'),
    description: t('prijzen.starter.description', 'Een krachtige onepager om jouw bedrijf professioneel op de kaart te zetten.'),
    ideal: t('prijzen.starter.ideal', 'zelfstandigen die snel en voordelig online willen met een professionele uitstraling.'),
    features: [
      t('prijzen.starter.features.0', 'Onepager / Landingspagina'),
      t('prijzen.starter.features.1', 'Responsief Design (desktop + mobiel)'),
      t('prijzen.starter.features.2', 'Basis SEO-optimalisatie'),
      t('prijzen.starter.features.3', 'Contactformulier'),
      t('prijzen.starter.features.4', 'Integratie van Google Maps & social media'),
      t('prijzen.starter.features.5', 'Oplevering binnen 1 week')
    ],
    maintenance: {
      price: 25,
      features: [
        t('prijzen.starter.maintenance.0', 'Beveiligingsupdates'),
        t('prijzen.starter.maintenance.1', 'Kleine aanpassingen (1x/maand)'),
        t('prijzen.starter.maintenance.2', 'Basis support per mail'),
        t('prijzen.starter.maintenance.3', 'Hosting inbegrepen')
      ]
    },
    popular: false
  },
  {
    id: 'business',
    name: t('prijzen.business.name', 'Business'),
    price: 1450,
    oldPrice: 1450,
    newPrice: 999,
    badge: t('prijzen.business.badge', '⭐ Meest gekozen'),
    description: t('prijzen.business.description', 'Voor bedrijven die klaar zijn voor de volgende stap en online willen groeien.'),
    ideal: t('prijzen.business.ideal', "ondernemers die meer pagina's, betere vindbaarheid en een hogere conversie wensen."),
    features: [
      t('prijzen.business.features.0', "Tot 5 op maat gemaakte pagina's"),
      t('prijzen.business.features.1', 'Responsief design (desktop + mobiel)'),
      t('prijzen.business.features.2', 'Uitgebreide SEO-structuur'),
      t('prijzen.business.features.3', 'Snelle laadtijden'),
      t('prijzen.business.features.4', 'Analytics dashboard'),
      t('prijzen.business.features.5', 'Oplevering binnen 1,5 à 2 weken')
    ],
    maintenance: {
      price: 40,
      features: [
        t('prijzen.business.maintenance.0', 'Beveiligingsupdates'),
        t('prijzen.business.maintenance.1', 'Kleine aanpassingen (2x/maand)'),
        t('prijzen.business.maintenance.2', 'E-mail & telefonische support'),
        t('prijzen.business.maintenance.3', 'Hosting inbegrepen')
      ]
    },
    popular: true
  },
  {
    id: 'premium',
    name: t('prijzen.premium.name', 'Premium'),
    price: 2850,
    oldPrice: 2850,
    newPrice: 1999,
    badge: t('prijzen.premium.badge', 'Voor professionals'),
    description: t('prijzen.premium.description', 'Voor merken die geen genoegen nemen met minder dan het allerbeste.'),
    ideal: t('prijzen.premium.ideal', 'bedrijven die maximale snelheid, vrijheid en een unieke digitale ervaring eisen.'),
    features: [
      t('prijzen.premium.features.0', 'Volledig Strapi CMS'),
      t('prijzen.premium.features.1', "Tot 8 pagina's"),
      t('prijzen.premium.features.2', 'Headless Setup (Next.js)'),
      t('prijzen.premium.features.3', 'Interactieve elementen & animaties'),
      t('prijzen.premium.features.4', 'Geavanceerde SEO & prestatieoptimalisatie'),
      t('prijzen.premium.features.5', 'Portfolio- of projectpagina (dynamisch beheerd)'),
      t('prijzen.premium.features.6', 'Oplevering binnen 3 à 4 weken')
    ],
    maintenance: {
      price: 65,
      features: [
        t('prijzen.premium.maintenance.0', 'Inclusief VPS Hosting & Database beheer'),
        t('prijzen.premium.maintenance.1', 'Onbeperkte kleine updates'),
        t('prijzen.premium.maintenance.2', 'Prioritaire support'),
        t('prijzen.premium.maintenance.3', 'Contentbeheer support'),
        t('prijzen.premium.maintenance.4', 'Dagelijkse Backups')
      ]
    },
    popular: false
  }
];

export const getExtras = (t) => [
  {
    category: t('prijzen.extras.basis.category', 'Basis Functionaliteiten'),
    items: [
      {
        id: 'extra-pages',
        title: t('prijzen.extras.basis.items.0.title', "Extra Pagina's (Advanced)"),
        price: 150,
        unit: t('prijzen.extras.basis.items.0.unit', 'per stuk'),
        description: t('prijzen.extras.basis.items.0.description', "Pagina's met custom designblokken en CMS-integratie"),
        icon: <Layout size={24} />
      },
      {
        id: 'multi-language',
        title: t('prijzen.extras.basis.items.1.title', 'Meertaligheid'),
        price: 175,
        unit: t('prijzen.extras.basis.items.1.unit', 'per taal'),
        description: t('prijzen.extras.basis.items.1.description', 'Bereik internationale klanten met meerdere talen'),
        icon: <Globe size={24} />
      },
      {
        id: 'blog-module',
        title: t('prijzen.extras.basis.items.2.title', 'Blogmodule (statisch)'),
        price: 95,
        description: t('prijzen.extras.basis.items.2.description', 'Deel nieuws en updates via een statische blog'),
        tag: t('prijzen.extras.basis.items.2.tag', 'Populair'),
        icon: <FileText size={24} />
      },
      {
        id: 'strapi-cms',
        title: t('prijzen.extras.basis.items.3.title', 'Strapi CMS'),
        price: 750,
        description: t('prijzen.extras.basis.items.3.description', 'Bestaande site ombouwen naar een beheersbare omgeving'),
        tag: t('prijzen.extras.basis.items.3.tag', 'Enterprise'),
        icon: <Database size={24} />
      }
    ]
  },
  {
    category: t('prijzen.extras.ecommerce.category', 'E-commerce & Verkoop'),
    items: [
      {
        id: 'shop-basic',
        title: t('prijzen.extras.ecommerce.items.0.title', 'Webshop basis'),
        price: 495,
        description: t('prijzen.extras.ecommerce.items.0.description', 'Tot 20 producten, inclusief betaalsysteem'),
        icon: <ShoppingBag size={24} />
      },
      {
        id: 'shop-advanced',
        title: t('prijzen.extras.ecommerce.items.1.title', 'Uitgebreide webshop'),
        price: 895,
        description: t('prijzen.extras.ecommerce.items.1.description', '100+ producten met geavanceerd beheer'),
        isVariable: true,
        icon: <Store size={24} />
      },
      {
        id: 'smart-content',
        title: t('prijzen.extras.ecommerce.items.2.title', 'Smart Content Modules'),
        price: 275,
        description: t('prijzen.extras.ecommerce.items.2.description', 'Vacaturebank, projectportfolio of nieuwsmodule met filtering'),
        isVariable: true,
        icon: <Briefcase size={24} />
      }
    ]
  },
  {
    category: t('prijzen.extras.marketing.category', 'Marketing & Optimalisatie'),
    items: [
      {
        id: 'newsletter',
        title: t('prijzen.extras.marketing.items.0.title', 'Nieuwsbrief koppeling'),
        price: 75,
        description: t('prijzen.extras.marketing.items.0.description', 'Mailchimp of Brevo integratie'),
        icon: <Mail size={24} />
      },
      {
        id: 'seo-boost',
        title: t('prijzen.extras.marketing.items.1.title', 'SEO-boostpakket'),
        price: 125,
        description: t('prijzen.extras.marketing.items.1.description', 'Inclusief meta-tags en optimalisatie'),
        icon: <TrendingUp size={24} />
      },
      {
        id: 'photography',
        title: t('prijzen.extras.marketing.items.2.title', "Fotografie + stockfoto's"),
        price: 195,
        description: t('prijzen.extras.marketing.items.2.description', 'Professionele beelden voor uw website'),
        isVariable: true,
        icon: <Camera size={24} />
      }
    ]
  }
];
